import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken, getUserSettings} from '../../storage'
import TemplateGeneral from './templates/templategeneral'
import {Link } from 'react-router-dom'
import {Loader} from '../../utils/misc'

const A4Portrait = () =>(
  <style>
{".preview-a4,.pharma-a5 {width: 210mm; min-height: 280mm;} @page {margin: 0;size: A4 portrait;min-height: 0;}"}
  </style>
)

function invoiceFont(size) {
  return <style>
  {".preview-a4,.pharma-a5{font-size: " + size + "px; }"
  +".preview-a4 .company-name {font-size: " + (size+7) + "px; } "
  + " .preview-a4 .table,.pharma-a5 .table {font-size: " + (size-1) + "px; }  "
   +"@page {font-size:" + size + "px;}"
   +"@print { .preview-a4 .table,.pharma-a5 .table  {font-size: " + (size-1) + "px; }"
    +".preview-a4 .company-name {font-size: " + (size+7) + "px; }}"
   }
  </style>
}
export default class PreviewGeneralCreditNote extends React.Component {


  constructor(){
    super()
    this.getCredit = this.getCredit.bind(this)
    this.state = {loading:true}
  }

  componentDidMount(){
    document.title = "General Credit Note " + this.props.match.params.retn_id
    this.getCredit(this.props.match.params.retn_id).then((response)=>{
      this.setState({retn:response.data.retn,
        company_profile: response.data.company_profile, loading:false})
    })
  }

  print(e) {
    e.preventDefault();
    window.print();
  }

  editLink(){
    this.props.history.push("/general_credit_notes/edit/"+this.props.match.params.retn_id)
  }

  getCredit(serial) {
    return axios({
      url: '/get_retn/?serial='+serial,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }
  render(){

    let settings = getUserSettings()
    let pageSize = <A4Portrait />
    let invoiceFontSize = invoiceFont(settings.invoice_font_size)
    let preview_style = <div>{pageSize}<TemplateGeneral credit={this.state.retn} company={this.state.company_profile} /></div>
    let editLink = <Link to={"/general_credit_notes/edit/"+this.props.match.params.retn_id} className="btn btn-primary" >Edit</Link>
    let printLink = <Link to="#" className="btn btn-success" onClick={this.print}>Print <span className="hidden-sm">(Ctrl+p)</span></Link>
    if(this.state.loading){
      return <div><Loader /></div>
    }
    else {
      return <div>
      <section className="small">
        <div className="hidden-print pull-left">
          <ul className="list-inline">
            <li>{editLink}</li>
            <li>{printLink}</li>
          </ul>
        </div>
      </section>
    {preview_style}
      </div>
    }

  }

}



// WEBPACK FOOTER //
// ./src/components/generalnote/previewgeneralcredit.js